export default function (state, { availableLocales }) {
  state.availableLocales = availableLocales;
}
